
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ListWidget',
  props: ['skills'],
  data() {
    return {
      bubbleStyle:
        'inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2',
    };
  },
});
